import { useSelector } from 'react-redux'
import { RootState } from '../ReduxStore.ts'
import { useGetUserDetailsQuery } from '../../features/SpeechAgendaApiSlice.ts'
import { useEffect, useState } from 'react'

export function useAppAuth() {
  const {
    user: firebaseUser,
    loading: firebaseUserLoading,
    needsRegistration,
  } = useSelector((state: RootState) => state.firebaseAuth)

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [userLoaded, setUserLoaded] = useState<boolean>()
  const {
    data: user,
    isLoading,
    isUninitialized,
  } = useGetUserDetailsQuery(undefined, {
    skip: !isAuthenticated,
  })

  useEffect(() => {
    setIsAuthenticated(!!firebaseUser && !needsRegistration)
    setUserLoaded(!(firebaseUserLoading || (!isUninitialized && isLoading)))
  }, [
    firebaseUser,
    firebaseUserLoading,
    isLoading,
    isUninitialized,
    needsRegistration,
  ])

  return {
    firebaseUser,
    user,
    isAuthenticated,
    userLoaded,
  }
}
